import * as React from 'react'
import LargeNumber from '../../../helper/large-number'
import Milliseconds from '../../../helper/milliseconds'

interface Props {
    message?: {
        args: {
            ct: number
            wt: number
        }
    }
}

export default class OrmQueryCache extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        if (message) {
            return (
                <div>
                    <p>
                        The <code>Doctrine\ORM\Query\Parser::parse</code> function was called{' '}
                        <LargeNumber value={message.args.ct} class="" /> times for <Milliseconds value={message.args.wt} /> in this trace.
                        Doctrine DQL Query parsing can be configured to be cached.
                    </p>

                    <p>
                        It is possible that you have DQL Query parsing enabled in your application, but this query is not cached, because it
                        was not executed yet or longer than the cache lifetime ago.
                    </p>

                    <p>See the Doctrine ORM and Symfony Documentation for more information on the query cache configuration:</p>

                    <ul>
                        <li>
                            <a href="https://www.doctrine-project.org/projects/doctrine-orm/en/current/reference/caching.html#query-cache">
                                Doctrine ORM Documentation: Caching - Query Cache
                            </a>
                        </li>
                        <li>
                            <a href="https://symfony.com/doc/current/reference/configuration/doctrine.html#caching-drivers">
                                Symfony Documentation: Doctrine Caching Drivers
                            </a>
                        </li>
                    </ul>
                </div>
            )
        }

        return (
            <div>
                <p>
                    The excessive use of <code>Doctrine\ORM\Query\Parser::parse</code> function can lead to performance issues.
                </p>
            </div>
        )
    }
}
